import { DATA_STATE_INVALID, DATA_STATE_SELECTED } from '../../../../constants';
import { getBorderWidth as getGlobalBorderWidth } from './global';
export function getBorderWidth(transformer) {
    const globalBorderWidth = getGlobalBorderWidth(transformer);
    return Object.freeze({
        containerDragAndDrop: { value: globalBorderWidth.normal },
        container: {
            default: { value: globalBorderWidth.normal },
            dataStates: {
                [DATA_STATE_SELECTED]: { value: globalBorderWidth.thick },
            },
        },
        form: {
            input: {
                default: { value: globalBorderWidth.normal },
                dataStates: {
                    [DATA_STATE_INVALID]: { value: globalBorderWidth.thick },
                },
            },
            amountInput: {
                default: { value: globalBorderWidth.thick },
            },
            datepicker: {
                date: { value: globalBorderWidth.thick },
            },
        },
        button: {
            secondary: { value: globalBorderWidth.normal },
            add: { value: globalBorderWidth.normal },
            plain: {
                withBorder: {
                    dataStates: {
                        [DATA_STATE_SELECTED]: { value: globalBorderWidth.normal },
                    },
                },
            },
        },
        divider: {
            default: { value: globalBorderWidth.normal },
            strong: { value: globalBorderWidth.thick },
            tableHeader: { value: globalBorderWidth.thick },
            total: { value: globalBorderWidth.thick },
        },
        modal: { value: globalBorderWidth.normal },
        menuItem: {
            dataStates: {
                [DATA_STATE_SELECTED]: {
                    default: { value: globalBorderWidth.normal },
                    multipleSelectable: { value: globalBorderWidth.none },
                },
            },
        },
        circle: {
            smallAttentional: { value: globalBorderWidth.none },
        },
        contentContainer: {
            tinted: { value: globalBorderWidth.none },
        },
    });
}
